interface INormalizedThemeProperties {
  [namespace: string]: {
    [propertyKey: string]: any;
  };
}

const NAMESPACE_SEPARATOR = '-';

/**
 * util for converting object like
 * ```
 * {
 *   "main-headerBackgroundColor": {value: "#FFF"}
 *   "main-headerTitleColor": {value: "#000"}
 * }
 * ```
 * to
 * ```
 * {
 *   main: {
 *     headerBackgroundColor: {value: "#FFF"},
 *     headerTitleColor: {value: "#000"}
 *   }
 * }
 * ```
 */
function normalizeStyleParamProperties(
  properties: Record<string, any>,
  initialState: INormalizedThemeProperties,
  mapPropertyValue?: (x) => any,
): INormalizedThemeProperties {
  return Object.keys(properties).reduce((acc, key) => {
    const [namespaceKey, propertyKey] = key.split(NAMESPACE_SEPARATOR);
    const propertyValue = properties[key];

    if (namespaceKey && propertyKey) {
      acc[namespaceKey] = acc[namespaceKey] || {};
      acc[namespaceKey][propertyKey] =
        typeof mapPropertyValue === 'function'
          ? mapPropertyValue(propertyValue)
          : propertyValue;
    }

    return acc;
  }, initialState);
}

export default normalizeStyleParamProperties;
